// extracted by mini-css-extract-plugin
export default {"tab":"toptab_tab__VEzu7"};